var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.549 12.75v6.5c0 3.358 2.21 4.063 4.062 4.063 1.853 0 4.063-.705 4.063-4.063v-6.5c0-3.358-2.21-4.063-4.063-4.063-1.852 0-4.062.705-4.062 4.063zM5.326 12.75v6.5c0 3.358 2.21 4.063 4.063 4.063 1.852 0 4.062-.705 4.062-4.063v-6.5c0-3.358-2.21-4.063-4.062-4.063-1.853 0-4.063.705-4.063 4.063z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 15.188v1.624H13.45v-1.625h3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.563 18.708v-5.416c0-.444.368-.813.812-.813.444 0 .813.369.813.813v5.416a.818.818 0 0 1-.813.813.818.818 0 0 1-.813-.813zM2.813 18.708v-5.416c0-.444.368-.813.812-.813.444 0 .813.369.813.813v5.416a.818.818 0 0 1-.813.813.818.818 0 0 1-.813-.813z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon-13.8db68214b4604d5322b6680f11436b0b.svg";
export { ForwardRef as ReactComponent };